import { IGetUser } from "../../interfaces/SeniorPlatform/IGetUser";
import { user } from '@seniorsistemas/senior-platform-data';

export async function getSeniorPlatformUser() {
    return user.getUserData().then((res: IGetUser) => res)
}